import React from "react";
import { Modal } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import TextFieldWithSuffix from "components/Ui/TextFieldWithSuffix";
import { client } from "services/api";

import {
  Button,
  FormControl,
  TextField,
} from "@mui/material";
import { useStore } from "_Store";
import { updateInititalStock } from "hooks/useCampaignData";
const initialValues = {
  //stocks: [],
};
const InitialStock = ({ visible, row, onSuccess, onCancel }) => {

  const {
    state:{
      activeCampaign,
      //activeFarm,
    },
    setUtils, setSelectedCampaignData
  } = useStore();
  //const { mutateAsync: updateCampaignStock } = updateInititalStock();
  React.useEffect(() => {
    return () => {
      formik.resetForm();
    }
  }, [row, visible]);

  const reloadCampaign = async () => {
    setUtils("loading", { spinning: true, primary: "" });
    const farmId = activeCampaign.farmId;
    let dt=new Date(activeCampaign.createdAt);
    const year=dt.getFullYear();
    const response = await client.get(
      `/campaign/getCampaign?farmId=${farmId}&year=${year}&campaignId=${activeCampaign.id}`
    );
    if (response.data.success) {
        setUtils("loading", { spinning: false, primary: "" });
        setSelectedCampaignData(response.data.data[0]);
    }
  }

  const close = () => {
    formik.resetForm();
    onCancel();
  };

  const validationSchema = yup.object().shape({
    // Define validation rules for other form fields...
  
    // Add validation rule for initial stock fields
    ...activeCampaign.productsYouGrow.reduce((schema, product) => {
      return {
        ...schema,
        [`initialStock_${product.productId}`]: yup.number()
          .typeError('Le stock initial doit petre un nombre')
          .min(0, 'Le stock intitial doit être au moins supérieur à 0')
          .required('La valeur du stock initial est requis'),
      };
    }, {}),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async(v) => {
      setUtils("loading", { spinning: true, primary: "" });
      const formattedStockValues = activeCampaign.productsYouGrow.map((product) => ({
        productId: product.productId,
        initialStock: v[`initialStock_${product.productId}`],
      }));      
      try {
        await updateInititalStock({ 
          stocks: formattedStockValues,
          campaignId: activeCampaign.id,
      }).then( async (res)=>{
        if (res.success) {
          close();
          onSuccess("post");
          formik.resetForm();
          await reloadCampaign();
        }
        console.log(res,'res data')
      });
      } catch (error) {
        // Handle error
      } finally {
        setUtils("loading", { spinning: false, primary: "" });
      }
    },
  });
  

/* const handleChange = (field) => (value) => {
  formik.setFieldValue(field, value);
}; */

  return (
    <React.Fragment>
      <Modal
        visible={visible}
        open={visible}
        width={500}
        title={"Stock Initial"}
        centered
        footer={null}
        onCancel={close}
      >
        <form onSubmit={formik.handleSubmit}>

<div>
  <h4 style={{ color:"orange" }}>Note : </h4>
  <p>Pour chaque culture, vous pouvez définir un stock inital. Le stock initial définis sera ajouter à la première <strong>ENTREE</strong>  ou <strong>SORTIE</strong> de l'opération de stockage.</p>
</div>

        {activeCampaign && activeCampaign.productsYouGrow ? (
            activeCampaign.productsYouGrow.map((product) => {
              return (
                <div className="mb-4" key={product.productId}>
                  <label className="mb-2">Définir le stock initial de la culture <strong> {product.seed.seedName} </strong></label>
                  <FormControl fullWidth>
                    <TextFieldWithSuffix
                      name={`initialStock_${product.productId}`}
                      inputLabel={`valeur du stock ${product.seed.seedName}`}
                      value={formik.values[`initialStock_${product.productId}`] || ""}
                      onChange={(e) => formik.handleChange(e.target.name)(e.target.value)}
                      error={formik.touched[`initialStock_${product.productId}`] && Boolean(formik.errors[`initialStock_${product.productId}`])}
                      helperText={formik.touched[`initialStock_${product.productId}`] && formik.errors[`initialStock_${product.productId}`]}
                      suffix={`${product.seed.seedUnite}`}
                    />
                  </FormControl>
                </div>
              );
            })
          ) : null}
      

          <p className="mt-4">&nbsp;</p>
          <div className="flex justify-between">
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="secondary"
              onClick={close}
            >
              Annuler
            </Button>
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="success"
              type="submit"
            >
              Mettre à jour
            </Button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default InitialStock;
